import {
  Sidebar,
  SidebarItems,
  SidebarItemGroup,
  SidebarItem,
  SidebarCollapse,
} from "flowbite-react";
import { NavLink } from "react-router-dom";
import { useSelector } from "react-redux";

import {
  LuLayoutDashboard,
  LuClipboardList,
  LuMap,
  LuLayers,
  LuMapPin,
  LuSearch,
} from "react-icons/lu";
import { RiAuctionLine } from "react-icons/ri";

function LinkItem({ to, label, icon: Icon }) {
  return (
    <SidebarItem as={NavLink} to={to} icon={Icon}>
      {label}
    </SidebarItem>
  );
}

export default function SideNav({ open }) {
  const authUser = useSelector((s) => s.auth?.user || null);
  const isAdmin = authUser?.role === "ADMIN";

  return (
    <aside
      className={`hidden md:block fixed top-[65px] left-0 h-[calc(100vh-65px)] border-r border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 transition-all ${
        open ? "w-64" : "w-16"
      }`}
    >
      <div className="h-full overflow-y-auto px-2 py-4">
        <Sidebar aria-label="Sidebar">
          <SidebarItems>
            <SidebarItemGroup>
              {/* Sempre visíveis */}
              <LinkItem
                to="/app/dashboard"
                label={open ? "Dashboard" : ""}
                icon={LuLayoutDashboard}
              />

              <LinkItem
                to="/app/auctions"
                label={open ? "Auctions" : ""}
                icon={RiAuctionLine}
              />

              <LinkItem
                to="/app/quick-search"
                label={open ? "Quick Search" : ""}
                icon={LuSearch}
              />

              {/* Apenas ADMIN */}
              {isAdmin && (
                <>
                  <LinkItem
                    to="/app/rules"
                    label={open ? "Regras" : ""}
                    icon={LuClipboardList}
                  />

                  <SidebarCollapse
                    icon={LuMap}
                    label={open ? "Geographical Divisions" : ""}
                  >
                    <SidebarItem as={NavLink} to="/app/states" icon={LuMap}>
                      States
                    </SidebarItem>

                    <SidebarItem as={NavLink} to="/app/regions" icon={LuLayers}>
                      Regions
                    </SidebarItem>

                    <SidebarItem
                      as={NavLink}
                      to="/app/counties"
                      icon={LuMapPin}
                    >
                      Counties
                    </SidebarItem>
                  </SidebarCollapse>
                </>
              )}
            </SidebarItemGroup>
          </SidebarItems>
        </Sidebar>
      </div>
    </aside>
  );
}
